import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Image
} from "react-bootstrap";
import AccessRights from 'utils/AccessRights';

const ListHeader = ({
  setAddEditModalShow,
  addEditmodalShow,
  ...rest
}) => {

  const dispatch = useDispatch();
  const session = useSelector((state) => state.session);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2 px-4 pt-4">

        <h1 className="font-24 font-weight-s-bold page-heading">Roles</h1>
        { (AccessRights(session.current_page_permissions, 'add'))?
        <button className='add-new-btn' variant='none' onClick={() => { setAddEditModalShow(true) }} ><Image src='/assets/images/add-icon.svg' className='me-2 add-user-icon' />Add New</button>
        : ''}
      </div>
    </>
  );
};

export default ListHeader;
